import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  logo: belongsTo('asset', { inverse: null }),
});
